import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Popover, Button, ButtonToolbar, OverlayTrigger } from 'react-bootstrap';
import cx from 'classnames';

import Link from '../../Link';
import messages from '../../../locale/jsonMessages';
import dotIcon from '/public/SiteIcons/adminTableDotIcon.svg';
import cs from '../../../components/commonStyle.css';

// Row actions of "Manage reservations" (R13): details, check-in, check-out, deposit and, only when it exists, the dispute.
// No independent check-in / check-out module: every entry opens the reservation (or its dispute) itself.
export function buildActionItems(reservation) {
  const id = reservation.id;
  const detail = `/siteadmin/viewreservation/${id}/reservation`;
  const items = [
    { key: 'details', to: detail, label: messages.inspAdmActionDetails },
    { key: 'checkin', to: `${detail}#checkin`, label: messages.inspAdmActionCheckin },
    { key: 'checkout', to: `${detail}#checkout`, label: messages.inspAdmActionCheckout },
    { key: 'deposit', to: `/siteadmin/viewreservation/${id}/security-deposit`, label: messages.inspAdmActionDeposit }
  ];
  // The dispute entry only exists when there is a dispute (R13).
  if (reservation.hasDispute) items.push({ key: 'dispute', to: `/siteadmin/reservation-dispute/${id}`, label: messages.inspAdmActionDispute });
  return items;
}

export function ReservationActionsMenu({ reservation }) {
  const { formatMessage } = useIntl();
  const id = reservation.id;
  const items = buildActionItems(reservation);
  return (
    <ButtonToolbar>
      <OverlayTrigger
        placement="bottom"
        rootClose
        trigger="click"
        overlay={(
          <Popover id={`reservation-actions-${id}`} placement="bottom" className="tableActionPopOver">
            {items.map((item) => (
              <Link key={item.key} to={item.to} className={cx(cs.dFlex, cs.noTextDecration, cs.commonMediumText, cs.fontWeightBold, cs.siteTextColor, 'popoverContentPadding', 'wordBreak', cs.alignItemBaseline)}>
                <span>{formatMessage(item.label)}</span>
              </Link>
            ))}
          </Popover>
        )}
      >
        <Button className={cs.tabelDropDownBtn} aria-label={formatMessage(messages.inspAdmActions)}>
          <img src={dotIcon} alt="" />
        </Button>
      </OverlayTrigger>
    </ButtonToolbar>
  );
}

ReservationActionsMenu.propTypes = { reservation: PropTypes.shape({ id: PropTypes.number.isRequired, hasDispute: PropTypes.bool }).isRequired };

export default ReservationActionsMenu;
